<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md10 lg8 :style="{width: '90vw', margin: 'auto', textAlign: 'center'}">
        <v-card color="primary">
          <h1>Phone Kitting</h1>
          <h3 class="mb-3" v-if="showSecondScreen">IMEI: {{repair[0].name}}</h3>

          <div v-if="showFirstScreen">
            <v-select
              :items="allPrinters"
              v-model="selectedPrinter"
              color="secondary"
              label="Select Printer"
              box
              :style="{width: '50%', margin: 'auto'}"
            ></v-select>
            <v-text-field
              v-model="imei"
              box
              :style="{width: '50%', margin: 'auto'}"
              name="imei"
              label="IMEI/MEID"
              color="secondary"
            ></v-text-field>
            <v-btn
              color="success"
              :disabled="imei == '' || selectedPrinter == ''"
              @click="searchRepair();"
            >Next</v-btn>
          </div>

          <div v-if="showSecondScreen">
            <v-text-field
              box
              :style="{width: '50%', margin: 'auto'}"
              v-model="iccid"
              name="ICCID"
              label="ICCID"
              color="secondary"
            ></v-text-field>
            <v-layout column>
              <v-btn
                class="mt-3"
                :style="{width: '30%', margin: 'auto', height: '65px'}"
                color="success"
                :disabled="iccid.length < 20"
                @click="saveRepair();"
              >Save ICCID</v-btn>
              <v-btn
                class="mt-3"
                :style="{width: '30%', margin: 'auto', height: '65px'}"
                color="secondary"
                @click="printLabel();"
                :disabled="!enablePrint"
              >Print Label</v-btn>
              <v-btn
                class="my-3"
                :style="{width: '30%', margin: 'auto', height: '65px'}"
                @click="reset();"
              >New Device</v-btn>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "phones",
  data() {
    return {
      imei: "",
      iccid: "",
      showFirstScreen: true,
      showSecondScreen: false,
      foundRepair: false,
      enablePrint: false,
      printOnComplete: false
    };
  },

  computed: {
    ...mapGetters({
      storedPrinter: "repair/getSelectedPrinter",
      allPrinters: "repair/getAllPrinters",
      repair: "repair/getRepair"
    }),
    selectedPrinter: {
      get() {
        return this.storedPrinter;
      },
      set(val) {
        return this.$store.commit("repair/setSelectedPrinter", val);
      }
    }
  },

  async beforeMount() {
    this.reset();
    await this.getAllPrinters();
  },

  methods: {
    ...mapActions({
      getAllPrinters: "repair/getAllPrinters",
      searchRepairStore: "repair/searchServices",
      updateRepair: "repair/updateRepair",
      printLabelStore: "repair/printPhoneLabel",
      completeRepairStore: "repair/completeRepair"
    }),
    async searchRepair() {
      if (this.imei) {
        await this.searchRepairStore({ serial: this.imei });
        if (this.repair[0]) {
          this.foundRepair = this.repair[0];
          this.showSecondScreen = true;
          this.showFirstScreen = false;
        } else {
          this.$store.dispatch("app/setSnackbar", {
            text: "Device not in system.",
            color: "red"
          });
        }
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "Please scan an IMEI/MEID",
          color: "red"
        });
      }
    },
    async saveRepair() {
      this.foundRepair.x_iccid = this.iccid;
      if (this.foundRepair.x_iccid) {
        await this.updateRepair({body:{
          id: this.foundRepair.id,
          x_iccid: this.foundRepair.x_iccid}
        });
        this.enablePrint = true;
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "Please scan an ICCID",
          color: "red"
        });
      }
    },
    async printLabel() {
      const { bindle } = await this.printLabelStore({
        printer: this.selectedPrinter,
        imei: this.imei
      });

      if (!bindle.success) {
        this.$store.dispatch("app/setSnackbar", {
          text: bindle.msg,
          color: "red"
        });
      }
    },

    reset() {
      this.imei = "";
      this.iccid = "";
      this.showFirstScreen = true;
      this.showSecondScreen = false;
      this.foundRepair = false;
      this.enablePrint = false;
    }
  }
};
</script>

<style>
</style>